import { Layout } from 'antd';
import React, { Suspense } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import styled from 'styled-components';
import ErrorBoundary from '@tools/ui/components/common/ErrorBoundary';
import TrackedRoute from '@tools/ui/components/common/layout/TrackedRoute';
import Loading from '@tools/ui/components/common/Loading';
import { semanticTheme } from '@tools/ui/dime';
import type { ModuleRouter } from '@tools/ui/types';

const { Content } = Layout;

const ContentContainer = styled(Content)`
  z-index: 1;
`;

const RouteContainer = styled(({ backgroundColor, ...props }) => <Content {...props} />)<{
  backgroundColor?: string;
}>`
  padding: 24px 24px 0 24px;
  z-index: 1;
  background: ${({ backgroundColor }) =>
    backgroundColor ?? semanticTheme.dime.colors.background.primary};
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
`;

type IProps = {
  defaultRoute: {
    redirectFrom: string[];
  };
  routes: ModuleRouter[];
};

const PageContent: React.FC<React.PropsWithChildren<IProps>> = ({ defaultRoute, routes }) => {
  return (
    <ContentContainer>
      <ErrorBoundary>
        <Switch>
          <Suspense fallback={<Loading />}>
            {routes.map(({ component: Component, name, path, exact, backgroundColor, ...rest }) => (
              <TrackedRoute path={path} key={name} exact={exact}>
                <RouteContainer backgroundColor={backgroundColor}>
                  <Component
                    router={{
                      component: Component,
                      name,
                      path,
                      exact,
                      ...rest,
                    }}
                  />
                </RouteContainer>
              </TrackedRoute>
            ))}
          </Suspense>
          <TrackedRoute exact path={defaultRoute.redirectFrom}>
            <Redirect to={defaultRoute.redirectFrom[1]} />
          </TrackedRoute>
        </Switch>
      </ErrorBoundary>
    </ContentContainer>
  );
};

export default PageContent;
